import React, { useMemo } from 'react';
import { SelectBox } from '../design-system';
import styles from './drugClassSelector.module.scss';
import { DrugClassIcon } from './drugClassIcon/DrugClassIcon.component';
import { DRUG_CLASSES } from 'shared/constants';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useSelector } from 'react-redux';

function DrugOption({ option }) {
  return (
    <div className={styles.option}>
      {option.label}
      <DrugClassIcon drugClass={option.value} tooltip={false} />
    </div>
  );
}

function DrugClassSelector({ value, errors, onChange, placeholder, ...props }) {
  const lang = useSelector(getLang('DRUG_CLASSES'));

  const options = useMemo(
    () =>
      Object.values(DRUG_CLASSES).map(drugClass => ({
        value: drugClass,
        label: lang[drugClass],
      })),
    [lang],
  );

  return (
    <SelectBox
      value={value ? value : null}
      options={options}
      error={errors?.drugClass}
      placeholder={placeholder}
      name="drugClass"
      onChange={onChange}
      allowClear
      optionRender={option => <DrugOption option={option} />}
      labelRender={option => <DrugOption option={option} />}
      {...props}
    />
  );
}

export { DrugClassSelector };
